import { net_common } from "@/api/http";
export const API_DisplayFileProcessingScreen = (...params) =>
  net_common.post("/api/STDSDC01C21/DisplayFileProcessingScreen", ...params);

